import React, { Component, useState, useEffect } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';
import { Icon } from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import OxigenTherapyForm from './OxigenTherapyForm.js'

//New survey img
import new_survey_button from '../../Images/Healthform/New_survey.png';

class OxiDisplayNewForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            displayBreathingFormPopup: false,
            scheduleOxy: [],
            oxygenRateTime: "min",
        };

    }

    togglePopup = () => {
        if (this.props.breathing.oxi_schedule !== undefined && this.props.breathing.oxi_schedule.length > 0) {

            if (this.props.breathing.oxi_schedule[this.props.breathing.oxi_schedule.length - 1] !== undefined) {

                // get last breathing value
                let lastBreathingValue = this.props.breathing.oxi_schedule[0].value

                // Fill Oxy schedule with existing data
                this.state.scheduleOxy = []         // empty existing state
                let scheduleOxyTmp = JSON.parse(lastBreathingValue)
                if (typeof(scheduleOxyTmp) === "string") {
                    scheduleOxyTmp = JSON.parse(scheduleOxyTmp)
                }
                scheduleOxyTmp.forEach(part => {
                    let dateTmp2 = new Date(part.start)                    
                    this.state.scheduleOxy.push(dateTmp2)
                    })
            }
        }
        this.setState(
            { displayBreathingFormPopup: !this.state.displayBreathingFormPopup }
        )
    }

    //Display render
    render(){
        return (
            <div style={{ flex:1, flexDirection:'column', alignItems:'center', justifyContent:'center', paddingTop:"30%"}}>

                    {this.props.accountInformation.readOnly === true ?
                        null
                        :
                    <button onClick={this.togglePopup} style={{backgroundColor:"transparent"}}>
                        <img src={new_survey_button} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "35px"}} alt="new_survey_logo"/>
                    </button>
                    }
                    {this.state.displayBreathingFormPopup ?
                        <OxigenTherapyForm
                            cancelPopup={this.togglePopup}
                            id_patient={this.props.id_patient}
                            update={this.props.update}
                            BannerDisplayedAlerts={this.state.BannerDisplayedAlerts}
                            scheduleOxy={this.state.scheduleOxy}
                            oxygenRateTime={this.state.oxygenRateTime}
                            start_date={this.props.start_date}
                            end_date={this.props.end_date}
                            screenSize={this.props.screenSize}
                        />
                        :
                        null
                    }
            </div>
        );
    }
}
export default (OxiDisplayNewForm);